import type { ComponentType } from 'react';
import { PopupManager } from 'react-popup-manager';
import type { OpenPopupOptions } from 'react-popup-manager/dist/src/__internal__/popupManagerInternal';

const scheduleAfterClosedPaint = (callback: VoidFunction) => {
    if (typeof globalThis.requestAnimationFrame !== 'function') {
        globalThis.setTimeout(callback, 0);
        return;
    }

    globalThis.requestAnimationFrame(() => globalThis.requestAnimationFrame(callback));
};

export const createAutoUnmountPopupManager = (): PopupManager => {
    const popupManager = new PopupManager();
    const open = popupManager.open;

    popupManager.open = <T>(componentClass: ComponentType<T>, popupProps?: OpenPopupOptions<T>) => {
        const popup = open(componentClass, popupProps);
        // react-popup-manager keeps closed popups mounted for transitions. ODSU hides the modal
        // immediately, so retain the closed state for one paint and then release its full subtree.
        const unmount = () => scheduleAfterClosedPaint(() => popup.unmount());

        void popup.response.then(unmount, unmount);

        return popup;
    };

    return popupManager;
};
